
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  linkClassName?: string;
}

const Logo = ({
  className,
  linkClassName
}: LogoProps) => {
  return (
    <Link to="/" className={cn("transition-transform duration-300 hover:scale-105", linkClassName)}>
      <img src="/logo_dark.png" alt="MediHub" className={cn("w-56", className)} />
    </Link>
  );
};

export default Logo;
